// extracted by mini-css-extract-plugin
export default {"description":"PRMResume_description__FK1hz","title":"PRMResume_title__YJcZn"};